import { Box, IconButton, styled } from '@material-ui/core';
import { distances } from '@setvi/shared/styles';
import { CSSProperties } from 'react';

export const Header = styled(Box)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gridGap: 12,
  padding: theme.spacing(3, 3, 3, 4)
}));

export const Content = styled(Box)({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  padding: `${distances.px.base} ${distances.px.large}`
});

export const Ratings = styled(Box)({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: distances.medium,
  gridGap: 19
});

interface CustomStyle {
  borderColor: CSSProperties['borderColor'];
  backgroundColor: CSSProperties['backgroundColor'];
  fill: CSSProperties['fill'];
}

export const RatingItem = styled(IconButton)({
  padding: distances.base,
  borderRadius: 120,
  width: 48,
  height: 48,
  backgroundColor: ({ customStyle }: { customStyle?: CustomStyle }) =>
    customStyle.backgroundColor,
  border: ({ customStyle }: { customStyle?: CustomStyle }) =>
    `1px solid ${customStyle.borderColor}`,
  '&:hover': {
    backgroundColor: ({ customStyle }: { customStyle?: CustomStyle }) =>
      customStyle.backgroundColor !== 'transparent' &&
      customStyle.backgroundColor
  },

  '& svg path': {
    fill: ({ customStyle }: { customStyle?: CustomStyle }) => customStyle.fill
  }
});

export const Footer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gridGap: 12,
  padding: theme.spacing(4, 3)
}));
